import cn from 'bem-cn';

import { List, Skeleton, Stack } from '../../../UI';

import './ChallengePrizes.scss';

const b = cn('challenge-prizes');

const renderPrize = () => <Skeleton variant="rounded" height={175} style={{ borderRadius: 32 }} />;
const extractTagKey = (_: unknown, index: number) => `skeleton-prize-${index}`;

export const ChallengePrizesSkeleton = () => {
    return (
        <Stack spacing={16} className={b()}>
            <h2 className={b('title')}>
                <Skeleton width="70%" />
            </h2>
            <List
                direction="row"
                className={b('list')}
                items={[1, 2, 3, 4]}
                renderItem={renderPrize}
                keyExtractor={extractTagKey}
            />
            <Stack spacing={4} className={b('description')}>
                <Skeleton width="70%" />
                <Skeleton />
                <Skeleton width="80%" />
            </Stack>
        </Stack>
    );
};
